import Vue from 'vue'
import { MutationTree } from "vuex"

import { RoomResource, RoomsState } from "~/store/rooms/rooms.types"

export const state = (): RoomsState => ({
  data: {},
  filters: {}
})

export const mutations: MutationTree<RoomsState> = {
  SET_ROOM (state, room: RoomResource) {
    const { id } = room

    Vue.set(state.data, id, room)
  }
}
